
(function($) {

    skel
        .breakpoints({
            xlarge: '(max-width: 1680px)',
            large: '(max-width: 1280px)',
            medium: '(max-width: 980px)',
            small: '(max-width: 736px)',
            xsmall: '(max-width: 480px)'
        });

    $(function() {

        var $window = $(window),
            $body = $('body'),
            $wrapper = $('#page-wrapper'),
            $banner = $('#banner'),
            $header = $('#header');

        // Disable animations/transitions until the page has loaded.
        $body.addClass('is-loading');

        $window.on('load', function() {
            window.setTimeout(function() {
                $body.removeClass('is-loading');
            }, 100);
        });

        var mypath = window.location.pathname;
        var isMainPage = !(mypath.indexOf("contact.html") > -1);

        //console.log('isMainPage', isMainPage)

        

        // lazy loading images
        var bLazy = new Blazy({
                folder: "images/",
                breakpoints: [480,736,980,1280,1920],
            }
        );
        var bLazy = new Blazy({
                selector: ".b-lazy-map",
                folder: "images/maps/",
                breakpoints: [480,736,980,1280,1920],
            }
        );

        // copy navi to mobile navi
        $("#nav").html( $('.pushy-content ul').clone() );


        setHeaderImage();
        window.addEventListener('resize', setHeaderImage, { passive: true });


if (isMainPage){
        // defines markup enhancement regex
        var protocol = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim
            , scheme   = /(^|[^\/])(www\.[\S]+(\b|$))/gim;


        Handlebars.registerHelper('breaklines', function(text) {
            text = Handlebars.Utils.escapeExpression(text);
            text = text.replace(/(\r\n|\n|\r)/gm, '<br>');

            // autolink urls
            text = text.replace( protocol, '<a href="$1" target="_blank">$1</a>');
            text = text.replace( scheme,   '$1<a href="http://$2" target="_blank">$2</a>' );

            return new Handlebars.SafeString(text);
        });


        Events.init();
}    


        // Mobile?
        if (skel.vars.mobile)
            $body.addClass('is-mobile');
        else
            skel
            .on('-medium !medium', function() {
                $body.removeClass('is-mobile');
            })
            .on('+medium', function() {
                $body.addClass('is-mobile');
            });

        // Fix: Placeholder polyfill.
        //$('form').placeholder();

        // Accordion
        $('.accordion').accordion({
            "transitionSpeed": 400
        });


        // Prioritize "important" elements on medium.
        skel.on('+medium -medium', function() {
            // $.prioritize(
            //     '.important\\28 medium\\29',
            //     skel.breakpoint('medium').active
            // );
        });

        // Scrolly.
        $('.scrolly')
            .scrolly({
                speed: 1000,
                offset: $header.outerHeight(),
                //bgParallax: true,
            });



        // Header.
        if (skel.vars.IEVersion < 9)
            $header.removeClass('alt');

        if ($banner.length > 0 && $header.hasClass('alt')) {

            $window.on('resize', function() { $window.trigger('scroll'); });

            $banner.scrollex({
                bottom: $header.outerHeight() + 1,
                terminate: function() { $header.removeClass('alt'); },
                enter: function() { $header.addClass('alt'); },
                leave: function() { $header.removeClass('alt'); }
            });

        }

    });


})(jQuery);


var setHeaderImage = function(){
    var scale = 1920;
    var isRetina = window.devicePixelRatio > 1;
    var winWidth = isRetina ? window.innerWidth*2 : window.innerWidth;
    $([480,736,980,1280,1920]).each(function(i,w) {
        //console.log('test', w, window.innerWidth);
        if (w >= winWidth) {
            scale = w;
            return false;
        }
    });

    //console.log("scale", scale);
    $("#banner-start img").attr("src", "./../images/" + scale + "/FeWo_Doeschnitz.jpg");
}


// get url query params
// var urlParams;
// (window.onpopstate = function () {
//     var match,
//         pl     = /\+/g,  // Regex for replacing addition symbol with a space
//         search = /([^&=]+)=?([^&]*)/g,
//         decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
//         query  = window.location.search.substring(1);

//     urlParams = {};
//     while (match = search.exec(query))
//        urlParams[decode(match[1])] = decode(match[2]);

//     introDisplay();
// })();


